import ym from 'react-yandex-metrika';

const isProd = process.env.NODE_ENV === 'production';

export const specialClientClick = () => {
  return isProd && ym('reachGoal', 'special_client');
};

export const onSignPEPClick = () => {
  return isProd && ym('reachGoal', 'sms-signing');
};
